import React from 'react';

export const LazyLogin = React.lazy(() =>
  import('./Login').then((module) => ({ default: module.Login }))
);
